import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    launcher: 'Support',
    title: 'Support',
    subtitle: 'We answer within a day',
    close: 'Close',
    emptyTitle: 'No messages yet',
    emptyText: 'Tell us what happened — we will sort it out.',
    placeholder: 'What happened?',
    send: 'Send',
    attach: 'Attach',
    attachCamera: 'Camera',
    attachPhoto: 'Photo',
    attachFile: 'File',
    removeFile: 'Remove',
    fileTooBig: 'The file is over 5 MB — pick a smaller one',
    sending: 'Sending',
    sendFailed: 'Did not go through. Try again',
    blocked: 'You cannot write to support right now.',
    needsPayment: 'Support chat opens after your first top-up. Make a payment and write to us.',
    loadOlder: 'Load earlier messages',
    loadError: 'Could not load the conversation',
    retry: 'Try again',
    operator: 'Support',
    system: 'SHOT',
    download: 'Download',
    fileUnavailable: 'The file did not open',
    sticker: 'Sticker',
    contact: 'Contact',
    contactNoPhone: 'no number',
    location: 'Location',
    poll: 'Poll',
    unsupported: 'A “{{kind}}” message',
    openChat: 'Write to support',
    kindText: 'Message',
    kindPhoto: 'Photo',
    kindVideo: 'Video',
    kindVideoNote: 'Video message',
    kindVoice: 'Voice message',
    kindAudio: 'Audio',
    kindDocument: 'File',
    kindSticker: 'Sticker',
    kindAnimation: 'GIF',
    kindContact: 'Contact',
    kindLocation: 'Location',
    kindPoll: 'Poll',
    kindOther: 'Message',
  },
  ru: {
    launcher: 'Поддержка',
    title: 'Поддержка',
    subtitle: 'Отвечаем в течение суток',
    close: 'Закрыть',
    emptyTitle: 'Пока тут пусто',
    emptyText: 'Напиши, что случилось, — разберёмся.',
    placeholder: 'Что случилось?',
    send: 'Отправить',
    attach: 'Прикрепить',
    attachCamera: 'Камера',
    attachPhoto: 'Фото',
    attachFile: 'Файл',
    removeFile: 'Убрать',
    fileTooBig: 'Файл больше 5 МБ — выбери поменьше',
    sending: 'Отправляю',
    sendFailed: 'Не ушло. Попробуй ещё раз',
    blocked: 'Писать в поддержку сейчас нельзя.',
    needsPayment: 'Чат с поддержкой открывается после первого пополнения. Пополни счёт — и пиши.',
    loadOlder: 'Показать, что было раньше',
    loadError: 'Не получилось загрузить переписку',
    retry: 'Ещё раз',
    operator: 'Поддержка',
    system: 'SHOT',
    download: 'Скачать',
    fileUnavailable: 'Файл не открылся',
    sticker: 'Стикер',
    contact: 'Контакт',
    contactNoPhone: 'номер не передан',
    location: 'Геометка',
    poll: 'Опрос',
    unsupported: 'Сообщение вида «{{kind}}»',
    openChat: 'Написать в поддержку',
    kindText: 'Сообщение',
    kindPhoto: 'Фото',
    kindVideo: 'Видео',
    kindVideoNote: 'Кружок',
    kindVoice: 'Голосовое',
    kindAudio: 'Аудио',
    kindDocument: 'Файл',
    kindSticker: 'Стикер',
    kindAnimation: 'Гифка',
    kindContact: 'Контакт',
    kindLocation: 'Геометка',
    kindPoll: 'Опрос',
    kindOther: 'Сообщение',
  },
  uz: {
    launcher: 'Qoʻllab-quvvatlash',
    title: 'Qoʻllab-quvvatlash',
    subtitle: 'Bir kun ichida javob beramiz',
    close: 'Yopish',
    emptyTitle: 'Hozircha boʻsh',
    emptyText: 'Nima boʻlganini yoz — hal qilamiz.',
    placeholder: 'Nima boʻldi?',
    send: 'Yuborish',
    attach: 'Biriktirish',
    attachCamera: 'Kamera',
    attachPhoto: 'Rasm',
    attachFile: 'Fayl',
    removeFile: 'Olib tashlash',
    fileTooBig: "Fayl 5 MB dan katta — kichikrogʻini tanla",
    sending: 'Yuborilyapti',
    sendFailed: 'Yuborilmadi. Yana urin',
    blocked: 'Hozir qoʻllab-quvvatlashga yozib boʻlmaydi.',
    needsPayment: 'Qoʻllab-quvvatlash chati birinchi toʻlovdan keyin ochiladi. Hisobni toʻldir — va yoz.',
    loadOlder: 'Oldingi xabarlarni koʻrsatish',
    loadError: 'Yozishmalarni yuklab boʻlmadi',
    retry: 'Yana',
    operator: 'Qoʻllab-quvvatlash',
    system: 'SHOT',
    download: 'Yuklab olish',
    fileUnavailable: 'Fayl ochilmadi',
    sticker: 'Stiker',
    contact: 'Kontakt',
    contactNoPhone: 'raqam yoʻq',
    location: 'Joylashuv',
    poll: 'Soʻrovnoma',
    unsupported: '«{{kind}}» turidagi xabar',
    openChat: 'Qoʻllab-quvvatlashga yozish',
    kindText: 'Xabar',
    kindPhoto: 'Rasm',
    kindVideo: 'Video',
    kindVideoNote: 'Video xabar',
    kindVoice: 'Ovozli xabar',
    kindAudio: 'Audio',
    kindDocument: 'Fayl',
    kindSticker: 'Stiker',
    kindAnimation: 'GIF',
    kindContact: 'Kontakt',
    kindLocation: 'Joylashuv',
    kindPoll: 'Soʻrovnoma',
    kindOther: 'Xabar',
  },
  fa: {
    launcher: 'پشتیبانی',
    title: 'پشتیبانی',
    subtitle: 'تا یک روز جواب می‌دهیم',
    close: 'بستن',
    emptyTitle: 'هنوز پیامی نیست',
    emptyText: 'بگو چه شده — درستش می‌کنیم.',
    placeholder: 'چه اتفاقی افتاده؟',
    send: 'بفرست',
    attach: 'پیوست',
    attachCamera: 'دوربین',
    attachPhoto: 'عکس',
    attachFile: 'فایل',
    removeFile: 'حذف',
    fileTooBig: 'فایل بیشتر از 5 مگابایت است — کوچک‌ترش را بفرست',
    sending: 'در حال ارسال',
    sendFailed: 'ارسال نشد. دوباره تلاش کن',
    blocked: 'الان نمی‌توانی به پشتیبانی پیام بدهی.',
    needsPayment: 'چت پشتیبانی بعد از اولین شارژ باز می‌شود. پرداخت کن و برایمان بنویس.',
    loadOlder: 'پیام‌های قبلی را بیاور',
    loadError: 'گفتگو باز نشد',
    retry: 'دوباره تلاش کن',
    operator: 'پشتیبانی',
    system: 'SHOT',
    download: 'دانلود',
    fileUnavailable: 'فایل باز نشد',
    sticker: 'استیکر',
    contact: 'مخاطب',
    contactNoPhone: 'بدون شماره',
    location: 'موقعیت',
    poll: 'نظرسنجی',
    unsupported: 'پیام «{{kind}}»',
    openChat: 'به پشتیبانی بنویس',
    kindText: 'پیام',
    kindPhoto: 'عکس',
    kindVideo: 'ویدیو',
    kindVideoNote: 'پیام ویدیویی',
    kindVoice: 'پیام صوتی',
    kindAudio: 'صدا',
    kindDocument: 'فایل',
    kindSticker: 'استیکر',
    kindAnimation: 'گیف',
    kindContact: 'مخاطب',
    kindLocation: 'موقعیت',
    kindPoll: 'نظرسنجی',
    kindOther: 'پیام',
  },
});
